var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37104 19.613L8.00207 15.5408L8.46082 15.9491L4.83722 20.0311L4.37104 19.613Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C4.93827 22 0 17.0617 0 11C0 4.93827 4.93827 0 11 0C17.0617 0 22 4.93827 22 11C22 17.0617 17.0617 22 11 22ZM11 0.629623C5.28395 0.629623 0.617284 5.28395 0.617284 11.0123C0.617284 16.7407 5.2716 21.3951 11 21.3951C16.7284 21.3951 21.3827 16.7407 21.3827 11.0123C21.3827 5.28395 16.7284 0.629623 11 0.629623Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7927 16.6033C7.82355 16.6033 5.39648 14.0957 5.39648 10.9995C5.39648 7.90337 7.81123 5.39575 10.7927 5.39575C13.7742 5.39575 16.1889 7.90337 16.1889 10.9995C16.1889 14.0957 13.7742 16.6033 10.7927 16.6033ZM10.7927 6.04825C8.15619 6.04825 6.01249 8.2744 6.01249 11.0123C6.01249 13.7502 8.15619 15.9764 10.7927 15.9764C13.4292 15.9764 15.5729 13.7502 15.5729 11.0123C15.5729 8.2744 13.4292 6.04825 10.7927 6.04825Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34718 6.22587L8.30176 0.540063L8.90441 0.414551L9.96213 6.10036L9.34718 6.22587Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup27);
export default __webpack_public_path__ + "static/media/Group27.28b18c10109ad239434bd514aa817bd9.svg";
export { ForwardRef as ReactComponent };